import { useSearchParams } from 'react-router-dom';
import { getQueryValue } from '@netiva/classifieds-common';

export const useAuthToken = () => {
  const [searchParams] = useSearchParams();
  const token = getQueryValue(searchParams.get('token'));
  return token;
};
